import { apiSlice } from '@/features/api/apiSlice';

export type ApiKeyScope =
  | 'send:write'
  | 'send:read'
  | 'templates:read'
  | 'templates:write'
  | 'webhooks:read';

export type ApiKeyRow = {
  id: string;
  name: string;
  prefix: string;
  scopes: ApiKeyScope[];
  environment: 'live' | 'test';
  rateLimitPerMin: number;
  lastUsedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
};

export type ApiKeyCreatedResponse = {
  id: string;
  name: string;
  prefix: string;
  token: string;
  scopes: ApiKeyScope[];
  environment: 'live' | 'test';
  expiresAt: string | null;
};

export const apiKeysApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listApiKeys: b.query<ApiKeyRow[], void>({
      query: () => '/api-keys',
      providesTags: ['ApiKey'],
    }),
    createApiKey: b.mutation<
      ApiKeyCreatedResponse,
      { name: string; scopes: ApiKeyScope[]; environment?: 'live' | 'test'; expiresInDays?: number }
    >({
      query: (body) => ({ url: '/api-keys', method: 'POST', body }),
      invalidatesTags: ['ApiKey'],
    }),
    revokeApiKey: b.mutation<void, string>({
      query: (id) => ({ url: `/api-keys/${id}`, method: 'DELETE' }),
      invalidatesTags: ['ApiKey'],
    }),
  }),
});

export const { useListApiKeysQuery, useCreateApiKeyMutation, useRevokeApiKeyMutation } = apiKeysApi;
